import { baseUrl, uploadUrl } from './config'

const install = (Vue, vm) => {

	uni.$u.http.setConfig((config) => {
		config.baseURL = baseUrl
		config.timeout = 60000
		return config
	})
	Vue.prototype.$baseUrl = baseUrl
	Vue.prototype.$uploadUrl = uploadUrl

	let wxAuthorize = (params = {}) => vm.$u.http.get('visitsAdmin/cloudService/web/visitor/wxAuthorize', { params })	// 访客微信授权
	let getSystemDictData = (params = {}) => vm.$u.http.get('visitsAdmin/cloudService/web/other/getSystemDictData', { params })	// 查询字典值数据
	let getProblemsVO = (params = {}) => vm.$u.http.get('visitsAdmin/cloudService/web/problem/getProblemsVO', { params })	// 获取题目数据
	let finishAnswer = (data = {}) => vm.$u.http.post('visitsAdmin/cloudService/web/problem/finishAnswer', data)	// 修改当前登录的用户信息
	let deviceRoleList = (params = {}) => vm.$u.http.get('visitsAdmin/cloudService/web/other/deviceRoleList', { params })	// 设备组列表
	let getVisitedMember = (data = {}) => vm.$u.http.post('visitsAdmin/cloudService/web/visitor/getVisitedMember', data)	// 查询被访问人信息
	let createFk = (data = {}) => vm.$u.http.post('visitsAdmin/cloudService/web/visitor/createFk', data)	// 访客记录提交
	let detail = (params = {}) => vm.$u.http.get('visitsAdmin/cloudService/web/visitor/detail', { params })	// 访客记录详情



	vm.$u.api = {
		wxAuthorize,
		getSystemDictData,
		getProblemsVO,
		finishAnswer,
		deviceRoleList,
		getVisitedMember,
		createFk,
		detail
	}
}

export default { install }